<template>
    <v-container fluid>
        <v-row style="padding-bottom: 20px;">
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="12"
                xl="2"
                lg="3"
                md="2"
                sm="2"
            >
                <h3>Material Requisition Report</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col 
                cols="12"
                lg="6"
                md="6"
                sm="12"
            >
                <v-menu
                    ref="mnuStartDate"
                    v-model="mnuStartDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>Start Date</label>
                        <v-text-field
                            v-model="filter.startDateFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.startDate"
                        no-title
                        @input="mnuStartDate = false"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col 
                cols="12"
                lg="6"
                md="6"
                sm="12"
            >
                <v-menu
                    ref="mnuEndDate"
                    v-model="filter.mnuEndDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>End Date</label>
                        <v-text-field
                            v-model="filter.endDateFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.endDate"
                        no-title
                        @input="mnuEndDate = false"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-divider style="margin-bottom: 15px;"></v-divider>
            </v-col>
        </v-row>

        <v-row>
            <v-col 
                cols="12"
                lg="6"
                md="4"
                sm="12"
            >
                <label>Category</label>
                <v-combobox
                    v-model="filter.categorySelected"
                    :items="listProductCategory" 
                    item-text="description"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="filter.subCategorySelected = null; getListSubCategory();"
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="5"
                md="4"
                sm="6"
            >
                <label>Sub Category</label>
                <v-combobox
                    v-model="filter.subCategorySelected"
                    :items="listProductSubCategory" 
                    item-text="description"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="getRegisters()"
                ></v-combobox>
            </v-col>
            <v-col 
                style="text-align: right; margin-top: 22px;"
                cols="12"
                lg="1"
                md="1"
                sm="8"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            @click="getRegisters"
                        >
                            Refresh
                        </v-btn>
                    </template>
                    <span>Refresh</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">        
                <v-tabs
                    v-model="tabReport"
                    fixed-tabs
                >
                    <v-tab key="1" @click="getRegisters">
                        By Product
                    </v-tab>
                    <v-tab key="2" @click="getRegisters">
                        By Project
                    </v-tab>
                </v-tabs>
                
                <v-tabs-items v-model="tabReport">

                    <!-- BY PRODUCT -->
                    <v-tab-item key="1">
                        <br />

                        <v-col 
                            style="text-align: right;"
                            cols="12"
                        >
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="exportFile(URL_REPORT_MATERIAL_REQUISITION_BY_PRODUCT, getFilterRequest());"
                                    >
                                        Export PDF
                                    </v-btn>
                                </template>
                                <span>Export Report to PDF</span>
                            </v-tooltip>
                        </v-col>

                        <v-col cols="12">
                            <v-data-table
                                :headers="headersByProduct"
                                :items="listMaterialRequisitionByProduct"
                                :options.sync="options"
                                :loading="loading"
                                :items-per-page="10"
                                :single-expand="true"
                                show-expand
                                no-data-text="No Record Found"
                                @click:row="showDetails"
                            >
                                <template v-slot:item.qtd="{ item }">
                                    <strong>{{ item.qtd }} </strong>                                    
                                </template>

                                <template v-slot:item.valueFormatted="{ item }">
                                    <strong>{{ item.valueFormatted }} </strong>                                    
                                </template>

                                <template v-slot:expanded-item="{ headers, item }">
                                    <td :colspan="headers.length">
                                        <h3 style="margin-top: 10px;">Details</h3>
                                        <table cellspacing="10" style="width: 90%; border: none; margin: 15px;">
                                            <thead style="text-align: left;">
                                                <tr>
                                                    <th>Job Id</th>
                                                    <th>Project</th>
                                                    <th>Qty</th>
                                                    <th>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody style="padding: 10px;">
                                                <tr v-for="(itemDetail, index) in item.listDetails" :key="index">
                                                    <td>
                                                        <v-tooltip left>
                                                            <template v-slot:activator="{ on }">
                                                                <a @click="goToServiceDetails(itemDetail.jobId)" v-on="on" target="_blank">
                                                                    {{ itemDetail.jobIdFormatted }}
                                                                </a>
                                                            </template>
                                                            <span>Job Details</span>
                                                        </v-tooltip>
                                                    </td>
                                                    <td>{{ itemDetail.projectDescription }}</td>
                                                    <td>{{ itemDetail.qty }}</td>
                                                    <td>{{ itemDetail.valueFormatted }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </template>

                                <template
                                    v-slot:footer
                                >
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <tbody style="padding: 10px;">
                                            <tr>
                                                <td style="width: 5%">&nbsp;</td>
                                                <td style="width: 65%; font-size: 25px; font-weight: bold;">Totals</td>
                                                <td style="width: 15%;" >
                                                    <v-chip dark>{{ totalsByProduct.qty }}</v-chip>
                                                </td>
                                                <td>
                                                    <v-chip dark>{{ totalsByProduct.value }}</v-chip>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-tab-item>

                    <!-- BY PROJECT -->
                    <v-tab-item key="2">
                        <br />

                        <v-col 
                            style="text-align: right;"
                            cols="12"
                        >
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="exportFile(URL_REPORT_MATERIAL_REQUISITION_BY_PROJECT, getFilterRequest());"
                                    >
                                        Export PDF
                                    </v-btn>
                                </template>
                                <span>Export Report to PDF</span>
                            </v-tooltip>
                        </v-col>

                        <v-col cols="12">
                            <v-data-table
                                :headers="headersByProject"
                                :items="listMaterialRequisitionByProject"
                                :options.sync="options"
                                :loading="loading"
                                :items-per-page="10"
                                :single-expand="true"
                                show-expand
                                no-data-text="No Record Found"
                                @click:row="showDetails"
                            >
                                <template v-slot:item.qtd="{ item }">
                                    <strong>{{ item.qtd }} </strong>                                    
                                </template>

                                <template v-slot:item.valueFormatted="{ item }">
                                    <strong>{{ item.valueFormatted }} </strong>                                    
                                </template>

                                <template v-slot:expanded-item="{ headers, item }">
                                    <td :colspan="headers.length">
                                        <h3 style="margin-top: 10px;">Details</h3>
                                        <table cellspacing="10" style="width: 90%; border: none; margin: 15px;">
                                            <thead style="text-align: left;">
                                                <tr>
                                                    <th>Product</th>
                                                    <th>Qty</th>
                                                    <th>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody style="padding: 10px;">
                                                <tr v-for="(itemDetail, index) in item.listDetails" :key="index">
                                                    <td>
                                                        <v-tooltip left>
                                                            <template v-slot:activator="{ on }">
                                                                <a @click="goToProductDetails(itemDetail.idProduct)" v-on="on" target="_blank">
                                                                    {{ itemDetail.productName }}
                                                                </a>
                                                            </template>
                                                            <span>Product Details</span>
                                                        </v-tooltip>
                                                    </td>
                                                    <td>{{ itemDetail.qty }}</td>
                                                    <td>{{ itemDetail.valueFormatted }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </template>

                                <template
                                    v-slot:footer
                                >
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <tbody style="padding: 10px;">
                                            <tr>
                                                <td style="width: 5%">&nbsp;</td>
                                                <td style="width: 65%; font-size: 25px; font-weight: bold;">Totals</td>
                                                <td style="width: 15%;" >
                                                    <v-chip dark>{{ totalsByProject.qty }}</v-chip>
                                                </td>
                                                <td>
                                                    <v-chip dark>{{ totalsByProject.value }}</v-chip>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-tab-item>

                </v-tabs-items>

            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import * as moment from 'moment';
    import { formaterDecimalBR } from '@/utilities/Utils';
    import { 
        URL_REPORT_MATERIAL_REQUISITION_BY_PRODUCT,
        URL_REPORT_MATERIAL_REQUISITION_BY_PROJECT
    } from "@/utilities/Enums";

    export default ({

        mixins: [Helpers],

        data: () => ({
            
            loading: false,
            
            tabReport: null,

            listProductCategory: [],
            listProductSubCategory: [],

            filter: {
                categorySelected: null,
                subCategorySelected: null,
                startDate: moment().clone().startOf('month').format('YYYY-MM-DD'),
                endDate: moment().clone().endOf('month').format('YYYY-MM-DD'),
                startDateFormatted: moment().clone().startOf('month').format('MM/DD/YYYY'),
                endDateFormatted: moment().clone().endOf('month').format('MM/DD/YYYY')
            },

            headersByProduct: [
                { text: "Product", value: "productName", width:"70%", sortable: true },
                { text: "Qty", value: "qty", width:"15%", sortable: true },
                { text: "Amount", value: "valueFormatted", width:"15%", sortable: true },
            ],

            headersByProject: [
                { text: "Project", value: "projectDescription", width:"70%", sortable: true },
                { text: "Qty", value: "qty", width:"15%", sortable: true },
                { text: "Amount", value: "valueFormatted", width:"15%", sortable: true },
            ],

            options: { rowsPerPage: 10, page: 1 },
            listMaterialRequisitionByProduct: [],
            listMaterialRequisitionByProject: [],
            
            mnuStartDate: false,            
            mnuEndDate: false,

            URL_REPORT_MATERIAL_REQUISITION_BY_PRODUCT,
            URL_REPORT_MATERIAL_REQUISITION_BY_PROJECT
        }),

        watch: {
            "filter.startDate" () {
                this.filter.startDateFormatted = this.formatDate(this.filter.startDate)
                this.getRegisters();
            },

            "filter.endDate" () {
                this.filter.endDateFormatted = this.formatDate(this.filter.endDate)
                this.getRegisters();
            },
        },

        computed: {
            totalsByProduct() {
                let qty = 0;
                let value = 0;

                if (this.listMaterialRequisitionByProduct != null && this.listMaterialRequisitionByProduct != undefined) {
                    this.listMaterialRequisitionByProduct.forEach(item => {
                        qty += item.qty;
                        value += parseFloat(item.value);
                    })
                }

                return {
                    qty,
                    value: `$ ${formaterDecimalBR(value.toFixed(2))}`
                }
            },

            totalsByProject() {
                let qty = 0;
                let value = 0;

                if (this.listMaterialRequisitionByProject != null && this.listMaterialRequisitionByProject != undefined) {
                    this.listMaterialRequisitionByProject.forEach(item => {
                        qty += item.qty;
                        value += parseFloat(item.value);
                    })
                }

                return {
                    qty,
                    value: `$ ${formaterDecimalBR(value.toFixed(2))}`
                }
            }
        },

        methods: {

            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },

            async getListSubCategory() {

                let idProductCategory = 0;
                
                if (this.filter.categorySelected != null && this.filter.categorySelected != undefined) {
                    idProductCategory = this.filter.categorySelected.id;
                }

                this.listProductSubCategory = await this.$store.dispatch("productSubCategoryModule/ListByCategory", idProductCategory);
            },

            async getLists() {
                this.listProductCategory = await this.$store.dispatch("productCategoryModule/List");
            },

            async getRegisters() {
                this.showLoading();
                await this.getByProduct();
                await this.getByProject();
                this.hideLoading();
            },
            
            getFilterRequest() {

                let idCategory = 0;
                let idSubCategory = 0;

                if (this.filter.categorySelected != null && this.filter.categorySelected != undefined) {
                    idCategory = this.filter.categorySelected.id;
                }

                if (this.filter.subCategorySelected != null && this.filter.subCategorySelected != undefined) {
                    idSubCategory = this.filter.subCategorySelected.id;
                }

                const startDate = this.filter.startDate;
                const endDate = this.filter.endDate;
                
                const request = {
                    idCategory,
                    idSubCategory,
                    startDate,
                    endDate
                }

                return request;
            },

            async getByProduct() {

                this.listMaterialRequisitionByProduct = await this.$store.dispatch("reportModule/MaterialRequisitionByProduct", this.getFilterRequest());
            },

            async getByProject() {

                this.listMaterialRequisitionByProject = await this.$store.dispatch("reportModule/MaterialRequisitionByProject", this.getFilterRequest());
            },

            showDetails(_, item2) {
                item2.expand(true);
            },

            goToProductDetails(id) {
                this.$router.push({ name: "productForm", params: {id: id} });
            },

            goToServiceDetails(id) {
                this.$router.push({ name: "serviceDetails", params: {id: id} });
            },
        },

        async created() {
            this.showLoading();
            await this.getLists();
            await this.getRegisters();
            this.hideLoading();
        }
    })
</script>

<style>

    table > tbody > tr {
        cursor: pointer !important;
    }

</style>